import VerifyPhone from './verifyPhone';

export default VerifyPhone;
